import { useIsAuthenticated } from "#/hooks/useIsAuthenticated";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

export function useBackBlock() {
  const history = useHistory();
  const { logoff } = useIsAuthenticated(false);
  const attemptsRef = useRef(0);
  const isLoggingOutRef = useRef(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action !== "POP") return;

      if (attemptsRef.current === 0) {
        alert(
          "Não existe ação de voltar para essa tela! Se precisar voltar, podemos deslogar e encaminhar para a tela principal."
        );
        attemptsRef.current += 1;
        return false;
      }

      if (!isLoggingOutRef.current) {
        isLoggingOutRef.current = true;
        setLoading(true);

        void (async () => {
          try {
            await Promise.resolve(logoff());
          } catch (err) {
            console.error("Erro ao fazer logout:", err);
          } finally {
            setLoading(false);
          }
        })();
      }

      return false;
    });

    return () => {
      unblock();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading };
}